import { Link, useNavigate } from "react-router";
import { sourceName } from "@/features/experiments/status";
import { ExperimentStatusPill } from "@/features/experiments/status-pill";
import type { ExperimentSummary } from "@/features/experiments/types";
import { formatRelative, formatScore } from "@/lib/format";
import { datasetLabel } from "@/features/experiments/dataset-label";

export function RecentExperiments({ experiments }: { experiments: ExperimentSummary[] }) {
  const navigate = useNavigate();
  return (
    <table className="tbl table-fixed">
      <thead>
        <tr>
          <th>Experiment</th>
          <th className="hidden w-[30%] md:table-cell">Dataset</th>
          <th className="num w-[84px]">Score</th>
          <th className="w-[120px]">Status</th>
          <th className="w-[96px]">When</th>
        </tr>
      </thead>
      <tbody>
        {experiments.map((e) => (
          <tr key={e.id} className="cursor-pointer" onClick={() => navigate(`/experiments/${e.id}`)}>
            <td>
              <div className="flex min-w-0 flex-col gap-0.5">
                <Link
                  to={`/experiments/${e.id}`}
                  onClick={(ev) => ev.stopPropagation()}
                  className="truncate font-semibold hover:underline"
                  title={e.name}
                >
                  {e.name}
                </Link>
                <span className="truncate text-xs text-muted">{sourceName(e)}</span>
              </div>
            </td>
            <td className="hidden truncate text-muted md:table-cell" title={e.dataset?.name}>
              {e.dataset ? datasetLabel(e.dataset) : "—"}
            </td>
            <td className="num font-mono">{formatScore(e.aggregate?.overall ?? null)}</td>
            <td>
              <ExperimentStatusPill experiment={e} />
            </td>
            <td className="text-xs whitespace-nowrap text-muted">{formatRelative(e.created_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
